import React from 'react';
export class CircleSnail extends React.Component {
    render() {
        return <h1>Loading</h1>;
    }
}
